import React from 'react'
import { CheckIcon, RotateCcwIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { usePricingCampaignContext } from '@/features/pricing-campaign/edit'

import { Button } from '@/shared/components/ui/button'
import { ModalClose, ModalFooter } from '@/shared/components/ui/modal'
import { Spinner } from '@/shared/components/ui/spinner'

export function PricingCampaignFormFooter() {
	const { t } = useTranslation()

	const context = usePricingCampaignContext()

	return (
		<ModalFooter className='pt-4'>
			<ModalClose asChild>
				<Button className='mr-auto'>{t('general_cancel')}</Button>
			</ModalClose>
			{(context.methods.formState.isDirty || context.isNew) && (
				<div className='flex items-center gap-2'>
					{!context.isNew &&
						!context.isSubmitting &&
						context.methods.formState.isDirty && (
							<Button
								data-testid='pc-form-revert-changes'
								onClick={context.handleReset}
								variant='ghost'
							>
								<RotateCcwIcon />
								{t('app.revert_changes')}
							</Button>
						)}
					{!context.isScenarioContext &&
						context.handleSubmitAndUpdate &&
						context.methods.formState.isDirty &&
						!context.isGlobalSetContext && (
							<Button
								disabled={
									!context.isReadyToChange ||
									context.isSubmitting ||
									context.isReadOnly
								}
								data-testid='pc-form-save-and-update'
								onClick={context.handleSubmitAndUpdate}
							>
								{context.isSubmitting && <Spinner />}
								{t('app.save_and_update')}
							</Button>
						)}
					<Button
						variant='warning'
						data-testid='pc-form-save'
						disabled={
							!context.isReadyToChange ||
							context.isSubmitting ||
							context.isReadOnly
						}
						onClick={context.handleSubmit}
					>
						{context.isSubmitting ? <Spinner /> : <CheckIcon />}
						{t('general_save')}
					</Button>
				</div>
			)}
		</ModalFooter>
	)
}
